module.exports = __webpack_public_path__ + "static/media/QueryNexus_logo.0e2c7895.png";